import React, { Fragment, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslate } from '@gameday/utils/hooks/useTranslate';
import { resourcePath } from '@gameday/utils/resource-path';
import useTracking from '@gameday/utils/hooks/useTracking';

import { Img, Picture, VoteLink } from '../PlayerOfTheGame.style';

const VotingDisplay = ({
    ContentContainer,
    voteLink,
    deviceInteraction,
    language = 'en',
    trackingProps
}) => {
    const translate = useTranslate();
    const Tracking = useTracking();

    const { light, dark } = useMemo(() => {
        return {
            light: resourcePath.get('playerOfTheGameArtwork', { theme: 'light', language }),
            dark: resourcePath.get('playerOfTheGameArtwork', { theme: 'dark', language })
        };
    }, [language]);

    const handleOnClick = useCallback((e) => {
        const anchorEl = e?.currentTarget;
        const { componentName = [] } = trackingProps;
        const cfg = {
            componentName: componentName.concat(['Player of the Game Vote']),
            text: e?.target?.innerText,
            activity: 'Link Click'
        };
        Tracking.track.track_click(cfg);

        if (anchorEl && deviceInteraction) {
            const link = anchorEl.getAttribute('href');
            if (deviceInteraction.webview({ url: link })) {
                e.preventDefault();
                return false;
            }
        }
    }, [deviceInteraction, trackingProps]);

    const Container = ContentContainer || Fragment;

    return (
        <Container>
            <Picture>
                <source srcSet={light} media="(prefers-color-scheme: light)"/>
                <source srcSet={dark} media="(prefers-color-scheme: dark)"/>
                <Img src={light} loading='lazy' />
            </Picture>
            <VoteLink href={voteLink} target="_blank" onClick={handleOnClick}>
                {translate('button_vote_and_see_results', 'Vote & See Results')}
            </VoteLink>
        </Container>
    );
};

VotingDisplay.propTypes = {
    ContentContainer: PropTypes.func,
    voteLink: PropTypes.string,
    leaderboardLink: PropTypes.string,
    deviceInteraction: PropTypes.object,
    language: PropTypes.string,
    trackingProps: PropTypes.object
};

export default VotingDisplay;
